import functions from "./functions.js";
import { Calendar } from './calendar.js';
import tplLoader from "./tpl-loader.js";

const dNone = 'd-none';
const $window = $(window);

const details = {
    // params
    $form: null,
    form: null,
    loading: false,
    loadId: 0,
    calendars: [],
    objectId: null,
    $units: null,
    hashTimeout: 0,
    params: {
        guests: '2,0'
    },
    $priceMin: null,
    priceMin: 0,
    $summaryNoDates: null,
    $summary: null,
    $summaryTotal: null,
    totalPrice: 0,
    totalPriceConverted: 0,
    submitted: false,
    calculated: {},
    $btnBook: null,
    btnBookHref: '',
    inquiryRequired: ['dates', 'firstName', 'lastName', 'email', 'phone', 'guests'],
    // methods
    init() {
        details.$form = $('.form-details');
        details.form = details.$form[0];

        if (!details.form) {
            return;
        }

        details.objectId = $('.od').attr('data-objectId');
        details.$priceMin = $('.price-min');
        details.$priceMinConverted = $('.price-min-converted');
        details.priceMin = details.$priceMin.html();
        details.priceMinConverted = details.$priceMinConverted.html();
        details.$summaryNoDates = $('.booking-summary-no-dates');
        details.$summary = $('.booking-summary');
        details.$summaryTotal = $('.booking-summary-total-price');
        details.$summaryTotalConverted = $('.booking-summary-total-price-converted');
        details.$btnBook = $('.btn-book');
        details.btnBookHref = details.$btnBook.attr('href') + '?addAllOptionals=1';

        details.$units = $('#booking .list-item');
        details.setLoading(true);
        details.calc();

        $window.on('hashchange', () => {
            details.setLoading(true);
            clearTimeout(details.hashTimeout);
            details.hashTimeout = setTimeout(() => details.calc(true), details.submitted ? 0 : 400);
        });

        details.$form.on('submit', e => {
            e.preventDefault();
            details.oldDateFrom = details.params.dateFrom;
            details.oldDateTo = details.params.dateTo;
            let data = functions.getFormData(details.$form);

            details.splitCalendarDates(data);
            data.persons == 2 && (delete data.persons);
            data.dates && (delete data.dates);
            data = $.param(data);

            if (location.hash !== '#' + data) {
                details.submitted = true;
                location.hash = data;
            } else {
                details.setLoading(true);
                setTimeout(() => {
                    details.setLoading(false, 300);
                    functions.scrollToElement(functions.smallWin() ? '.booking-section' : '#booking');
                }, 400);
            }
        });

        $('.apply-calendar').on('click', e => {
            setTimeout(() => {
                details.$form.trigger('submit');
            }, 500);
        });

        $('.clear-param').on('click', e => {
            let $elem = $(e.currentTarget);
            let name = $elem.attr('data-clear');
            details.params[name] = '';
            functions.setFormData(details.form, {[name]: ''});
        })

        details.$btnBook.on('click', e => {
            e.preventDefault()
            details.setContinueLink();
        })


        $('.od-units')
            .on('click', '.list-item-book', e => details.selectUnit($(e.target).closest('.list-item'), true))
            .on('click', '.list-item-unbook', e => details.selectUnit($(e.target).closest('.list-item'), false))
            /* unit show details */
            .on('show.bs.collapse', e => {
                $(e.target).prev().find('.list-item-show-details .fa').addClass('fa-angle-up');
                setTimeout(() => functions.scrollToElement(e.target, 150));
            })
            .on('hidden.bs.collapse', e => {
                $(e.target).prev().find('.list-item-show-details .fa').removeClass('fa-angle-up');
            })
            .on('click', '[data-open-tab]', e => {
                let tabId = $(e.currentTarget).attr('data-open-tab');
                // let unitId = $(e.currentTarget).attr('data-unitid');

                $(`[data-bs-toggle="tab"][data-bs-target="#${tabId}"]`).tab('show');
            })


            // load calendars
            $('.unit-calendar-open').on('shown.bs.tab', e => {
                let unitId = $(e.target).attr('data-unitid');

                if (details.calendars[unitId] || null) return;

                $.get('/services/details/?template=unit_calendar&publicId=' + details.objectId + '&language=' + functions.getLang() + '&unitId=' + unitId ).then(response => {

                    $('#unit-' + unitId + '-calendar').find('.unit-calendar').html(response.view);

                    details.calendarInit(unitId);
                    
                });
            });

        details.loadReviews();
        details.inquiryInit();
    },
    setLoading(state, timeout = 700) {
        details.loading = state;
        // details.$form.find('.btn[type="submit"]').prop('disabled', state).find('i').toggleClass(dNone, !state);
        if (state) $('.submit-loader-wrap').removeClass('d-none');
        else {
            setTimeout(() => {
                $('.submit-loader-wrap').addClass('d-none');
            }, timeout);
        }
    },
    setForm() {
        let urlData = $.extend({}, functions.getUrlData(true));
        !urlData.guests && (urlData.guests = '2,0,0');
        if (urlData.dateFrom && urlData.dateTo) urlData.dates = urlData.dateFrom + ' - ' + urlData.dateTo;
        functions.setFormData(details.form, urlData);
        details.params = urlData;
        details.splitCalendarDates(details.params);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status != 'Unavailable';
    },
    splitCalendarDates(params) {
        if (params.dates) {
            const aDates = params.dates.split(' - ');
            details.params.dateFrom = params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = params.dateTo = aDates[1] ? aDates[1] : null;
            details.params.dates = params.dates = null;
        }
    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 3;
            let page = +$button.data('page') + 1;
            let total = +$button.data('total');

            $.post('/services/reviews/', { language: functions.getLang(), perPage: perPage, page: page, 
                unitId: $button.attr('data-unitId') || undefined, 
                objectId: $button.attr('data-objectId') || undefined
             }).then(response => { 
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= (page * perPage)) {
                        $button.addClass('d-none');
                    }

                    $('.review-list').append(response.html);
                }
            });
        });
    },
    inquiryInit() {
        $('form#inquiry').find('#request-name, #request-surname, #request-email, #request-tel, #request-addres, .request-dates.input').focusout( function(e) {
            let $elem = $(this);
            let valid = true;
            
            if ($elem.attr('name') == 'email')
            {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                valid = regex.test($elem.val());
            }

            if ($elem.hasClass('request-dates'))
            {
                $elem = $('#request-dates');
            }

            if ( ! ($elem.val() && valid)) 
            {
                // validForm = false;
                $elem.addClass('input-empty');
                $elem.siblings('.invalid-feedback').addClass('d-block');
            }
            else
            {
                $elem.removeClass('input-empty');
                $elem.siblings('.invalid-feedback').removeClass('d-block');
            }
        })
        $('form#inquiry').on('submit', e => {
            e.preventDefault();
            let $currentTarget = $(e.currentTarget);
            $currentTarget.find('.contact-btn').addClass('d-none');
            $currentTarget.find('.contact-spinner').removeClass('d-none');
            $currentTarget.find('.contact-spinner').addClass('d-flex');

            let params = {};
            let allParams = $currentTarget.serializeArray();
            $.each(allParams, function (i, field) {
                params[field.name] = field.value;
            });
            let validForm = true;
            $currentTarget.find('#request-name, #request-surname, #request-email, #request-tel, #request-addres, .request-dates.input').each( function(e) {
                let $elem = $(this);
                let valid = true;
                // if ($elem.attr('name') ==)
                if ($elem.attr('name') == 'email')
                {
                    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    valid = regex.test($elem.val());
                }
    
                if ( ! ($elem.val() && valid)) 
                {
                    validForm = false;
                    $elem.addClass('input-empty');
                    $elem.siblings('.invalid-feedback').addClass('d-block');
                }
                else
                {
                    $elem.removeClass('input-empty');
                    $elem.siblings('.invalid-feedback').removeClass('d-block');
                }
            })
            if (! validForm)
            {   
                $currentTarget.find('.contact-btn').removeClass('d-none');
                $currentTarget.find('.contact-spinner').addClass('d-none');
                $currentTarget.find('.contact-spinner').removeClass('d-flex');
                return;
            }
            
            functions.setFormData($('form#inquiry'), params);
            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            grecaptcha.ready(function () {
                grecaptcha.execute('6LeAz5gUAAAAAKoZP6-NVwB5wTFGjyeCVGmm582z', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {

                        $currentTarget.addClass('d-none');
                        response.status ? $currentTarget.find('.request-success').removeClass('d-none') : $currentTarget.find('.request-error').removeClass('d-none');
                        let $resElem = $currentTarget.parent().find('.request-response-message');
                        $resElem.removeClass('d-none');
                        $resElem.html(response.data);
                        setTimeout(() => {
                            $currentTarget.parents('.request-form').find('.request-modal-close').click();
                            $currentTarget.parents('.request-form').find('.contact-btn').removeClass('d-none');
                            $currentTarget.parents('.request-form').find('.contact-spinner').addClass('d-none');
                            $currentTarget.parents('.request-form').find('.contact-spinner').removeClass('d-flex');
                            $currentTarget.removeClass('d-none');
                            $resElem.html('').addClass('d-none');
                        }, 7000);

                        if (response.status == true) {
                            $currentTarget[0].reset();
                        }


                    });
                });
            });
        });
    },
    calc(hashchange) {
        // debugger
        details.submitted = false;
        
        details.setForm();
        let ajaxId = ++details.loadId;
        let params = {
            dateFrom: details.params.dateFrom,
            dateTo: details.params.dateTo,
            guests: details.params.guests,
            publicId: details.objectId
        };

        if (!(details.oldDateFrom == details.params.dateFrom && details.oldDateTo == details.params.dateTo)) {
            details.deselectUnits();
        }

        if (details.params.dateFrom && details.params.dateTo) {
            // $('.submit-loader-wrap').removeClass('d-none');
            $('.calc-loader').addClass('loading').prepend(tplLoader);
            $('.calc-wrapper').css('opacity', 0);
            $('.calc-wrapper').css('display', 'none');
            $('.calc-msg').addClass('d-none').html('');

            $.post('/services/calc/', params).then(response => {
                if (ajaxId !== details.loadId) {
                    return;
                }
                // hashchange && functions.scrollToElement(functions.smallWin() ? '.booking-section' : '#booking');
                response = JSON.parse(response);
                details.calculated = response.length === undefined ? response : {};
                details.calcToHtml();

                setTimeout(() => {
                    let wh = $(window).outerHeight();
                    $('.calc-loader').removeClass('loading').find('.list-loader').remove();
                    $('.calc-wrapper').css('opacity', 1);
                    $('.calc-wrapper').css('display', 'flex');
                    // $('.submit-loader-wrap').addClass('d-none');
                    // if (functions.isMobile() && details.focusOnBooking) functions.scrollToElement($('.booking-scroll-hook'), wh);
                }, 700)
            });
        } else {
            details.setLoading(false);
            // $('.submit-loader-wrap').removeClass('d-none');
            $('.calc-loader').addClass('loading').prepend(tplLoader);
            $('.calc-wrapper').css('opacity', 0);
            $('.calc-wrapper').css('display', 'none');
            $('.calc-msg').addClass('d-none').html('');

            $('.list-item-price-value-from').removeClass('d-none');
            $('.list-item-payment-from').removeClass('d-none');
            $('.list-item-offer').removeClass('d-none');

            $('.list-item-price-value-total').addClass('d-none');
            $('.list-item-book').addClass('d-none');
            $('.list-item-payment-total').addClass('d-none');
            $('.text-error').addClass('d-none');

            setTimeout(() => {
                $('.calc-loader').removeClass('loading').find('.list-loader').remove();
                    $('.calc-wrapper').css('opacity', 1);
                    $('.calc-wrapper').css('display', 'flex');
                    $('.submit-loader-wrap').addClass('d-none');
                // hashchange && functions.scrollToElement(functions.smallWin() ? '.booking-section' : '#booking');
                // details.calcToHtml();
            }, 700);
        }
    },
    calcToHtml() {
        details.setLoading(false);
        let withDates = !!(details.params.dateFrom && details.params.dateTo);
        let prices = [];
        let pricesConverted = [];
        

        Object.entries(details.calculated.data).forEach(unit => {
            let unitId = unit[0];
            const $unit = $('[data-unitid=' + unitId + ']');
            let unitData = unit[1];
            // close details if opened
            $unit.find('.list-item-show-details[aria-expanded="true"]').click();
            // set html            
            let price = details.calculated[unitId];
            let priceConverted = 0;

            if (withDates && price && price.isAvailable) {
                priceConverted = price.calc.totalEUR;
                price = price.calc.total;
            } else {
                price = 0;
            }

            prices.push(price /*withDates && Math.round(Math.random()) ? Math.round(Math.random() * 100) : 0*/ );
            pricesConverted.push(priceConverted /*withDates && Math.round(Math.random()) ? Math.round(Math.random() * 100) : 0*/ );

            if ($unit.hasClass('unit-in-cart')) return;


            if (details.isBookable(unitData)) { // has price

                const unitCalc = unitData.calc;

                const calcItems = unitCalc.items;
                let priceOld = 0.00;
                let priceOldEUR = 0.00;
                let discountTitle = null;

                calcItems.forEach(item => {
                    // popust za djecu ne ulazi u prikaz discount cijene
                    if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                        priceOld += item.itemTotal;
                        priceOldEUR += item.itemTotalEUR;
                    }
                    if (item.itemType == 'discount') {
                        discountTitle = item.itemTitle;
                        if (item.data && item.data.text) {
                            discountTitle = item.data.text;
                        }
                    }
                });


                $unit.removeClass('bg-light-danger');
                $unit.attr('data-price', unitCalc.total);
                // $unit.attr('data-price-converted', pricesConverted[i]);
                $unit.find('.list-item-payment').removeClass(dNone);
                $unit.find('.list-item-price-value-total').removeClass(dNone).html('€ ' + unitCalc.total.toFixed(2));
                // $unit.find('.list-item-price-value-total-converted').html(pricesConverted[i].toFixed(2));
                $unit.find('.list-item-price-value-from').addClass(dNone);
                $unit.find('.list-item-price-text').addClass(dNone);

                if ($unit.hasClass('unit-in-cart')) {
                    $unit.find('.list-item-unbook').removeClass(dNone);
                } else {
                    $unit.find('.list-item-book').removeClass(dNone);
                }

                $unit.find('.list-item-offer').addClass(dNone);
                $unit.find('.list-item-payment-total').removeClass(dNone);
                $unit.find('.list-item-payment-from').addClass(dNone);
                $unit.find('.list-item-payment-total').removeClass(dNone);
                $unit.find('.list-item-payment-from').addClass(dNone);
            } else {
                if (withDates) {
                    $unit.addClass('bg-light-danger');
                    $unit.find('.list-item-payment').addClass(dNone);
                    $unit.find('.list-item-price-value-from').addClass(dNone);
                    $unit.find('.list-item-price-text').removeClass(dNone);
                } else {
                    $unit.removeClass('bg-light-danger');
                    $unit.find('.list-item-payment').removeClass(dNone);
                    $unit.find('.list-item-price-value-from').removeClass(dNone);
                    $unit.find('.list-item-price-text').addClass(dNone);

                }
                $unit.find('.list-item-price-value-total').addClass(dNone);
                $unit.removeAttr('data-price');
                $unit.removeAttr('data-price-converted');
                $unit.find('.list-item-book').addClass(dNone);
                $unit.find('.list-item-offer').removeClass(dNone);
            }
            let $offerBtn = $unit.find('.list-item-offer');
            if (!$offerBtn.attr('data-href')) {
                $offerBtn.attr('data-href', $offerBtn.attr('href') + '&');
            }
            $offerBtn.attr('href', $offerBtn.attr('data-href') + $.param(details.params));
        });
        // toogle no dates message based on dates
        // details.$summaryNoDates.toggleClass(dNone, withDates);
        // set min price
        // if (withDates) {
        //     let positivePrices = prices.filter(price => price > 0);
        //     let positivePricesConverted = pricesConverted.filter(price => price > 0);

        //     details.$priceMin.html(positivePrices.length ? '€ ' + Math.min(...positivePrices) : '--');
        //     details.$priceMinConverted.html(positivePricesConverted.length ? Math.min(...positivePricesConverted).toFixed(2) : '--');
        // } else {
        //     details.$priceMin.html(details.priceMin);
        //     details.$priceMinConverted.html(details.priceMinConverted);
        // }
    },
    setContinueLink() {

        let params = Object.assign({}, details.params),
            cart = [];

        details.$units.each((i, unit) => {
            if (unit.classList.contains('unit-in-cart')) {
                cart.push({
                    'unitId': unit.getAttribute('data-unitid'),
                    'dateFrom': params.dateFrom,
                    'dateTo': params.dateTo,
                    'guests': unit.getAttribute('data-guets'),
                    'quantity': 1
                });
            }
        });

        functions.setCookie('cart_data', JSON.stringify(cart));

        location = details.btnBookHref + '&cart_data=' + JSON.stringify(cart);
    },
    selectUnit($unit, state) {
        let price = +$unit.attr('data-price');
        let priceConverted = +$unit.attr('data-price-converted');

        details.totalPrice += (state ? 1 : -1) * price;
        details.totalPriceConverted += (state ? 1 : -1) * priceConverted;

        details.$summaryTotal.html('€ ' + details.totalPrice.toFixed(2));
        details.$summaryTotalConverted.html(details.totalPriceConverted.toFixed(2));

        details.$summary.toggleClass('disabled', !details.totalPrice);

        $unit.toggleClass('unit-in-cart', state);
        if (state) $unit.attr('data-guets', details.params.guests);
        else $unit.attr('data-guets', '0,0,0')
        $unit.find('.list-item-book').toggleClass(dNone, state);
        $unit.find('.list-item-unbook').toggleClass(dNone, !state);
        state && functions.smallWin() && functions.scrollToElement('#od-nav');
        let cartLen = +$('.cart-len').html();

        $('.cart-len').html(state ? cartLen+1 : cartLen-1);

         
        if (!state) {
            details.calcToHtml();
        } else {
            $unit.attr('data-persons', details.params.persons);
        }
    },
    deselectUnits() {
        details.totalPrice = 0;
        details.totalPriceConverted = 0;
        details.$summary.addClass('disabled');
        $('.cart-len').html(0);
        details.$units.each((i, unit) => {
            let $unit = $(unit);
            $unit.removeClass('unit-in-cart');
            $unit.find('.list-item-unbook').addClass(dNone);
        });
    },
    calendarInit(unitId) {
        let $elem = $('#unit-' + unitId + '-calendar').find('[data-calendarconfig]');
        let config = JSON.parse($elem.attr('data-calendarconfig'));

        let defaultDate = $elem.attr('data-defaultdate');
        let minDate = $elem.attr('data-mindate');
        /*if( ! details.params.dateFrom && defaultDate) {
            let dates = defaultDate.split(' - ');
            //details.params.dates = defaultDate;
            details.splitCalendarDates(defaultDate);
            defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
        }*/
        
        details.calendars[unitId] = new Calendar(
            $elem.find('.datepicker-range-book'),
            {
                availabilityMask: config.availabilityMask,
                startDate: config.startDate,
                minStay: config.minStay,
                periods: config.periods,
                translations: config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                minDate: minDate ? minDate : 'today',
                mode: 'range',
                inline: true,
                showMonths: 4,
                containerClass: 'details-booking-calendar mx-auto'
            },
            details.callbackOnDatesSelectedUnit
        );
    },
    callbackOnDatesSelectedUnit(from, to) 
    {
        if(from && to && $('.datepicker-range')[0]) $('.datepicker-range')[0]._flatpickr.setDate([from, to]);
    },
}

$(function() {

    details.init();

    // details sub navigation
    $('#od-nav').on('click', '.nav-link', e => {
        functions.scrollToElement($($(e.target).attr('href')), 150);
    });

    // google map    
    const $map = $('.od-map');
    if ($map.length) {
        let map;
        let mapTimeout;
        // check if in viewport
        if ($map[0].getBoundingClientRect) {
            $window.on('load, scroll', e => {
                if (map) {
                    return;
                }
                clearTimeout(mapTimeout);
                mapTimeout = setTimeout(() => {
                    let screenHeight = document.documentElement.clientHeight;
                    let mapBounds = $map[0].getBoundingClientRect();
                    if (screenHeight > mapBounds.top && mapBounds.bottom > 0) {
                        window.loadGoogleMaps();
                    }
                }, 1000);
            });
        } else {
            $window.on('load', e => window.loadGoogleMaps());
        }
        // map init
        $window.on('gMapsLoaded', e => {
            let center;
            try {
                center = JSON.parse($map.attr('data-lat-lng'));
            } catch (e) {}

            if (center) {
                map = new google.maps.Map($map[0], {
                    center: center,
                    zoom: 12,
                    styles: [{
                        featureType: 'poi.business',
                        elementType: 'labels',
                        stylers: [
                            { visibility: 'off' }
                        ]
                    }]
                });
                new google.maps.Circle({
                    map: map,
                    center: center,
                    radius: 800, // 10 miles in metres
                    fillColor: '#AA0000',
                    strokeOpacity: 0
                });
            }
        });
    }
    // end google map

    // slider init
    const slider = $("#slider-details").lightSlider({
        item: 3,
        mode: 'slide',
        pager: false,
        controls: false,
        slideMargin: 4,
        speed: 500,
        enableDrag: false,
        responsive: [{
            breakpoint: 1182,
            settings: {
                item: 1
            }
        }]
    });
    // slider navigation
    $('.od-header-slider').on('click', '.lSPrev, .lSNext', e => {
        if (e.currentTarget.classList.contains('lSPrev')) {
            slider.goToPrevSlide();
        } else {
            if (slider.getTotalSlideCount() - slider.getCurrentSlideCount() === 1) {
                slider.goToSlide(0);
            } else {
                slider.goToNextSlide();
            }
        }
    });

    /* place - other points of interest */
    const $othersList = $('.place-others-list');
    const $othersDetails = $('.place-others-details');
    if ($othersList.length) {
        $othersList.on('click', '[data-other]', function(e) {
            e.preventDefault();
            let $this = $(this);
            let id = $this.attr('data-other');
            let $detail = $othersDetails.find('[data-other-id="' + id + '"]');
            let $activeDetail = $othersDetails.find('.active');
            // hide
            $othersList.find('.active').removeClass('active');
            $activeDetail.removeClass('active').addClass(dNone);
            // show
            if ($activeDetail[0] !== $detail[0]) {
                $this.addClass('active');
                $detail.removeClass(dNone).addClass('active');
                functions.scrollToElement($othersDetails, functions.smallWin() ? 150 : 400);
            }
        });
        $othersDetails.on('click', '[data-other-id] .close', () => {
            $othersList.find('.active').removeClass('active');
            $othersDetails.find('.active').removeClass('active').addClass(dNone);
        });
    }
    /* end place - other points of interest */

    /* beach show features */
    $('#beach').on('show.bs.collapse', e => setTimeout(() => functions.scrollToElement(e.target, 150)));


});